<script setup lang="ts">
import { useThemeStore } from "~/stores/theme";
import { computed } from "vue";
import { useRoute } from "vue-router";

const themeStore = useThemeStore();
const themeColor = computed(() => themeStore.themeColor);
const route = useRoute();
</script>

<template>
    <div id="app-container" :class="themeColor">
        <div
            class="relative z-10 flex flex-col justify-between min-h-screen overflow-hidden transition-colors duration-150 bg-site dark:bg-site-dark"
        >
            <SiteHeader/>

            <main class="flex-grow">
                <RouterView :key="route.fullPath"/>
            </main>

            <SiteFooter/>
        </div>

    </div>
</template>

<style>

</style>